<template>
  <v-container fluid class="appraisals-list" v-if="appraisalList">
    <div class="content" v-if="!spinn">
      <div class="legend d-flex justify-center mb-5">
        <v-btn
          text
          v-for="it in itemsFilter"
          :key="it.value"
          @click="selectedItem = it.value"
        >
          {{ it.value }}
          <v-icon :color="it.color" right>mdi-square</v-icon>
        </v-btn>
      </div>
      <v-row>
        <v-col class="text-center">
          <v-select
            :items="itemsFilter"
            v-model="selectedItem"
            item-value="value"
            item-text="value"
            @change="selectedItem = $event"
            label="Filtrar por estado..."
            outlined
          ></v-select>
        </v-col>
        <v-col class="text-center">
          <v-text-field
            outlined
            v-model="search"
            label="Buscar..."
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-iterator
        :items="filteredData"
        :items-per-page.sync="itemsPerPage"
        :page.sync="page"
        hide-default-footer
      >
        <template v-slot:default="props">
          <div class="d-flex flex-row flex-wrap justify-center">
            <div
              v-for="(appraisal, index) in props.items"
              :key="index"
              class="tarjeta d-flex elevation-5"
              :style="[
                selectedItem == 'TODAS' ? { 'border-color': '#e0e0e0' } : '',
                selectedItem == 'PENDIENTES DATOS DEL VEHÍCULO'
                  ? { 'border-color': '#039BE5' }
                  : '',
                selectedItem == 'PENDIENTES DE TASACIÓN'
                  ? { 'border-color': '#FB8C00' }
                  : '',
                selectedItem == 'PENDIENTES DE VALIDACIÓN'
                  ? { 'border-color': '#FFEE58' }
                  : '',
                selectedItem == 'CONFIRMADAS'
                  ? { 'border-color': '#66BB6A' }
                  : ''
              ]"
            >
              <div class="carImage">
                <img :src="appraisal.thumbnail.image" alt="" />
              </div>
              <div class="carContent pa-2">
                <div class="head d-flex justify-space-between align-center">
                  <span>{{ appraisal.id }} - {{ appraisal.plate }}</span>
                  <v-btn
                    icon
                    right
                    @click="
                      appraisalList = false;
                      data.selected = appraisal;
                      getImages(appraisal.id);
                    "
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
                <span>{{ appraisal.brand }} - {{ appraisal.model }}</span>
                <v-divider class="mb-4 mt-2"></v-divider>
                <div class="body d-flex flex-column">
                  <span>Comercial: {{ appraisal.commercial_user_id }}</span>
                  <span>Tasador: {{ appraisal.appraiser_user_id }}</span>
                  <span
                    >Precio: {{ eur.format(appraisal.appraised_value) }}</span
                  >
                  <span
                    >Fecha:
                    {{
                      new Date(appraisal.created_at).toLocaleDateString()
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <span class="grey--text">Resultados por página</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  text
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer></v-spacer>

            <span
              class="mr-4
            grey--text"
            >
              Página {{ page }} de {{ numberOfPages }}
            </span>
            <v-btn fab dark color="primary" class="mr-1" @click="formerPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab dark color="primary" class="ml-1" @click="nextPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </template></v-data-iterator
      >
    </div>
    <v-progress-circular
      v-else
      :width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
  <v-container fluid v-else>
    <v-btn
      icon
      right
      @click="
        appraisalList = true;
        data.selected = '';
      "
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span>VOLVER</span>
    <AppraisalDetails v-if="selectedItem == 'CONFIRMADAS'" :data="data" />
    <AppraisalDetailsNew v-else :dataSelected="data.selected" />
  </v-container>
</template>

<script>
import { getMethodToken } from "@/api-consume/api-calls";
import store from "@/store/index";

import AppraisalDetails from "@/components/Home/ContentHome/Sections/AppraisalDetails.vue";
import AppraisalDetailsNew from "@/components/Home/ContentHome/Sections/AppraisalDetailsNew.vue";

export default {
  components: {
    AppraisalDetails,
    AppraisalDetailsNew
  },
  data: () => ({
    itemsPerPageArray: [3, 6, 9],
    page: 1,
    itemsPerPage: 6,
    search: "",
    url: process.env.VUE_APP_BASEURL,
    maxItems: 3,
    changeList: 0,
    itemsFilter: [
      { color: "#e0e0e0", value: "TODAS" },
      { color: "#039BE5", value: "PENDIENTES DATOS DEL VEHÍCULO" },
      { color: "#FB8C00", value: "PENDIENTES DE TASACIÓN" },
      { color: "#FFEE58", value: "PENDIENTES DE VALIDACIÓN" },
      { color: "#66BB6A", value: "CONFIRMADAS" }
    ],
    selectedItem: "",
    appraisalList: true,
    eur: Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }),
    spinn: false,
    snackbar: false,
    snackbarText: "",
    snackbarTimeout: 3000,
    snackbarColor: "",
    data: {
      tasaciones: "",
      selected: "",
      images: ""
    }
  }),
  computed: {
    numberOfPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    filteredData() {
      let obj = this.data.tasaciones;

      //Aplicamos la búsqueda
      if (this.search != "") {
        obj = obj.filter(item =>
          Object.keys(item).some(
            index =>
              item[index] != null &&
              item[index]
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase())
          )
        );
      }

      //Aplicamos el filtro
      switch (this.selectedItem) {
        case "CONFIRMADAS":
          obj = obj.filter(el => el.confirmed == 1);
          break;

        case "PENDIENTES DE TASACIÓN":
          obj = obj.filter(el => el.step_3 == 0 && el.step_2 == 1);
          break;

        case "PENDIENTES DE VALIDACIÓN":
          obj = obj.filter(el => el.step_3 == 1 && el.confirmed == 0);
          break;

        case "PENDIENTES DATOS DEL VEHÍCULO":
          obj = obj.filter(el => el.step_1 == 1 && el.step_2 == 0);
          break;
      }

      return obj;
    }
  },
  created() {
    this.getTasaciones();
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    filterByValue(array, string) {
      return array.filter(o =>
        Object.keys(o).some(k =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      );
    },
    async getImages(id) {
      this.spinn = true;
      const response = await getMethodToken("/api/appraisals/images/" + id);
      console.log("LISTA IMAGENES: ", response);

      if (response.status == 200) {
        this.data.images = response.data.payload.images;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
      this.spinn = false;
    },
    async getTasaciones() {
      this.spinn = true;
      if (
        store.state.userLogged.roles[0].rol == "ExternalCommercial" ||
        store.state.userLogged.roles[0].rol == "InternalCommercial"
      ) {
        const response = await getMethodToken(
          "/api/appraisals/assignee/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      } else if (store.state.userLogged.roles[0].rol == "Appraiser") {
        const response = await getMethodToken(
          "/api/appraisals/by-appraiser/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      } else if (store.state.userLogged.roles[0].rol == "Validator") {
        const response = await getMethodToken(
          "/api/appraisals/by-validator/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      }
      this.spinn = false;
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}
.tarjeta {
  width: 100%;
  height: 200px;
  width: 32% !important;
  margin: 10px;
  border: solid 1px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.carImage {
  margin-right: 10px;
  width: 40%;
}
.carImage img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.carContent {
  width: 60%;
}
</style>
